<div class="occasion-genius-list">
  <div class="occasion-genius-list__header">
    <h2 [class.sm]="title === 'Event Calendar'">{{title}}</h2>
    @if(!isFetching) {
      <button (click)="seeAll($event)" class="occasion-genius-list__see-all">
        See all
      </button>
    }
  </div>

  <div class="occasion-genius-list__content">
    @if(title === 'Events and Occasions') {
      <div class="occasion-genius-list__content--description">
        Discover events and special occasions happening around the city.
      </div>
    }

    @if (isFetching) {
      <div class="swiper" [class.sm]="title === 'Event Calendar'" appSwiper [swiperOptions]="swiperOptions">
        <div class="swiper-wrapper">
          @for (hotel of [1, 2, 3, 4]; track hotel; let idx = $index) {
            <div class="swiper-slide">
              <app-occasion-genius-card-mobile
                [isFetching]="isFetching"
              ></app-occasion-genius-card-mobile>
            </div>
          }
        </div>
        <div class="swiper-pagination"></div>
      </div>
    } @else if (groupEvents && groupEvents.length) {
        <div class="swiper" [class.sm]="title === 'Event Calendar'" appSwiper [swiperOptions]="swiperOptions">
            <div class="swiper-wrapper">
                @for (event of groupEvents | slice: 0:24; track event.uuid) {
                    @if(getCardEvent(event); as cardEvents) {
                        @if(cardEvents[0]) {
                            <div class="swiper-slide">
                                <app-occasion-genius-card-mobile
                                        [isFetching]="isFetching"
                                        [events]="cardEvents"
                                        [cityId]="cityId"
                                        [cityName]="cityName"
                                        [countryName]="countryName"
                                ></app-occasion-genius-card-mobile>
                            </div>
                        }
                    }
                }
            </div>
            <div class="swiper-pagination"></div>
        </div>
    } @else {
        <app-no-items-found title="EMPTY.EVENTS"></app-no-items-found>
    }
  </div>

  @if(!(authService.isLogged$ | async) && groupEvents?.length) {
    <div class="occasion-genius-list__auth">
      <div class="occasion-genius-list__auth--container">
        <h3 class="occasion-genius-list__auth--title">
          Unlock Access to {{cityName}} Events!
        </h3>
        <p class="occasion-genius-list__auth--description">
          Sign up to add must-see events to your trip plan and make the most of your time in Milan!
        </p>
        <button class="btn-default btn-green occasion-genius-list__auth--sign-in" (click)="openAuthDialog()">
            Join now
        </button>
      </div>
    </div>
  }
</div>
